// Billing months are calendar dates, independent of the viewer's timezone.
export function formatServiceMonth(value) {
  const match = /^(\d{4})-(\d{2})(?:-|$)/.exec(value || "");
  if (!match || Number(match[2]) < 1 || Number(match[2]) > 12) return "N/A";
  return new Intl.DateTimeFormat("en-US", { year: "numeric", month: "short", timeZone: "UTC" }).format(new Date(Date.UTC(Number(match[1]), Number(match[2]) - 1, 1)));
}
export function formatComparisonValue(value, currency = false) {
  if (value === null || value === undefined || value === "" || !Number.isFinite(Number(value))) return "N/A";
  return `${currency ? "$" : ""}${Math.round(Number(value)).toLocaleString("en-US")}`;
}
export function formatComparisonPercent(value) {
  return value === null || value === undefined || value === "" || !Number.isFinite(Number(value)) ? null : `${(Number(value) * 100).toFixed(2)}%`;
}
